const pt = {
  // Common
  common: {
    back: '← Voltar',
    backToLogin: '← Voltar ao Login',
    backToCadastro: '← Voltar ao Cadastro',
    loading: 'Carregando...',
    error: 'Erro',
    success: 'Sucesso',
    required: 'obrigatório',
    save: 'Salvar',
    cancel: 'Cancelar',
    search: 'Buscar',
    na: 'N/A',
  },

  // HomePage
  home: {
    subtitle: 'Sistema de Certificados de Aplicação',
    btnApplicator: 'Sou Aplicador',
    btnCertificate: 'Ver Certificado',
  },

  // LoginPage
  login: {
    title: 'Área do Aplicador',
    subtitle: 'Faça login para acessar o sistema de cadastro',
    email: 'Email',
    emailPlaceholder: 'Digite seu email',
    password: 'Senha',
    passwordPlaceholder: 'Digite sua senha',
    submit: 'Entrar',
    submitting: 'Entrando...',
    forgotPassword: 'Esqueci a senha',
    rememberMe: 'Lembrar por 30 dias',
    noAccount: 'Ainda não tem uma conta?',
    register: 'Cadastrar novo aplicador',
    successMessage: '✅ Login realizado com sucesso!',
    errorMessage: '❌ Erro ao realizar login. Tente novamente.',
    methodPassword: 'Email e Senha',
    methodCpf: 'CPF + Código',
    cpfLabel: 'CPF',
    cpfPlaceholder: 'Digite seu CPF cadastrado',
    sendCode: 'Enviar Código',
    sendingCode: 'Enviando...',
    changeCpf: '← Usar outro CPF',
    codeLabel: 'Código recebido por email',
    codePlaceholder: 'Digite o código de 6 dígitos',
    codeHint: 'Enviamos um código para o email cadastrado com esse CPF. Confira também a caixa de spam.',
    verifyCode: 'Entrar',
    verifyingCode: 'Verificando...',
    resendCode: 'Reenviar código',
  },

  // CadastroAplicadorPage
  register: {
    title: 'Cadastro de Aplicador',
    subtitle: 'Preencha os dados para criar uma nova conta de aplicador',
    fullName: 'Nome Completo',
    fullNamePlaceholder: 'Digite o nome completo',
    email: 'Email',
    emailPlaceholder: 'Digite o email',
    cpfCnpj: 'CPF ou CNPJ',
    phone: 'Telefone (com DDD)',
    phonePlaceholder: '(00) 00000-0000',
    instagram: 'Instagram',
    instagramPlaceholder: 'seu.perfil',
    password: 'Senha',
    passwordPlaceholder: 'Crie uma senha',
    confirmPassword: 'Confirmar Senha',
    confirmPasswordPlaceholder: 'Confirme a senha',
    showPassword: 'Mostrar',
    hidePassword: 'Ocultar',
    submit: 'Cadastrar Aplicador',
    submitting: 'Cadastrando...',
    goToLogin: 'Ir para o Login',
    successMessage: 'Aplicador cadastrado com sucesso! Agora você pode fazer login.',
    errorMessage: 'Erro ao cadastrar aplicador. Tente novamente.',
    passwordMismatch: 'As senhas não coincidem.',
    passwordMinLength: 'A senha deve ter pelo menos 8 caracteres.',
    passwordComplexity: 'A senha deve conter pelo menos uma letra minúscula, uma maiúscula e um número.',
    // Studio section
    studioSection: 'Endereço do Estúdio',
    studioName: 'Nome do Estúdio *',
    studioNamePlaceholder: 'Ex: Studio Detailing Center',
    studioCep: 'CEP *',
    studioCepPlaceholder: '00000-000',
    studioEndereco: 'Rua / Logradouro *',
    studioEnderecoPlaceholder: 'Preenchido pelo CEP',
    studioNumero: 'Número *',
    studioNumeroPlaceholder: 'Nº',
    studioComplemento: 'Complemento',
    studioComplementoPlaceholder: 'Sala, Bloco, etc.',
    studioBairro: 'Bairro *',
    studioBairroPlaceholder: 'Preenchido pelo CEP',
    studioCidade: 'Cidade *',
    studioCidadePlaceholder: 'Preenchido pelo CEP',
    studioEstado: 'UF *',
    studioEstadoPlaceholder: 'UF',
    studioCepSearching: 'Buscando CEP...',
    studioCepError: 'CEP não encontrado. Preencha manualmente.',
  },

  // BuscaCertificadoPage
  certificate: {
    title: 'Consultar Certificados',
    subtitle: 'Informe seus dados para visualizar seus certificados de aplicação',
    cpf: 'CPF',
    cpfPlaceholder: 'Digite seu CPF',
    searchBtn: 'Buscar Certificados',
    searching: 'Buscando...',
    notFound: 'Nenhum certificado encontrado para os dados informados.',
    errorSearch: 'Erro ao buscar certificados. Verifique os dados e tente novamente.',
    found: 'Certificados Encontrados',
    certId: 'ID do Certificado:',
    applicationDate: 'Data de Aplicação:',
    vehicleData: 'Dados do Veículo',
    model: 'Modelo:',
    color: 'Cor:',
    plate: 'Placa:',
    serialNumber: 'Serial Number:',
    applicator: 'Aplicador:',
    location: 'Local:',
    vehiclePhoto: 'Foto do Veículo',
    warrantyPerProduct: 'Certificado por Produto',
    warranty: 'Certificado:',
    validUntil: 'Válido até:',
    active: 'Ativa - Restam',
    warning: 'Atenção - Restam',
    expired: 'Certificado Expirado',
    dateUnavailable: 'Data indisponível',
    maintenance: 'Manutenção Recomendada',
    maintenanceText: 'Recomendamos a manutenção do revestimento a cada <strong>6 meses</strong> a partir da data de aplicação para manter a proteção e o brilho do veículo.',
    maintenanceUpcoming: 'Manutenção Próxima!',
    maintenanceNext: 'Próxima Manutenção',
    maintenanceToday: 'Hoje ou em atraso',
    maintenanceTomorrow: 'Amanhã',
    maintenanceInDays: 'Em {{days}} dias',
    scheduleWhatsapp: 'Agende sua manutenção',
    whatsappMessage: 'Olá, vi que preciso realizar uma manutenção/avaliação no coating cerâmico do meu veículo',
    contactApplicator: 'Aplicador: <strong>{{name}}</strong> — Entre em contato para agendar a manutenção.',
    allExpired: 'CERTIFICADOS EXPIRADOS',
    attentionBadge: 'CERTIFICADO DE APLICAÇÃO - ATENÇÃO',
    validBadge: 'CERTIFICADO DE APLICAÇÃO VÁLIDO',
  },

  // Studios
  studios: {
    title: 'Meus Estúdios',
    subtitle: 'Gerencie os endereços dos seus estúdios',
    addStudio: 'Adicionar Estúdio',
    editStudio: 'Editar Estúdio',
    deleteStudio: 'Excluir',
    deleteConfirm: 'Tem certeza que deseja excluir este estúdio?',
    noStudios: 'Nenhum estúdio cadastrado.',
    saveSuccess: 'Estúdio salvo com sucesso!',
    deleteSuccess: 'Estúdio removido com sucesso!',
    errorSave: 'Erro ao salvar estúdio.',
    errorDelete: 'Erro ao remover estúdio.',
    errorLoad: 'Erro ao carregar estúdios.',
    selectStudio: 'Selecione o estúdio *',
    selectPlaceholder: 'Selecione um estúdio...',
    noStudiosRegistered: 'Nenhum estúdio cadastrado. Cadastre um estúdio em "Meus Cadastros" primeiro.',
  },

  // MeusCadastrosPage
  myCerts: {
    title: 'Meus Cadastros',
    subtitle: 'Veículos registrados por {{name}}',
    subtitleDefault: 'Veículos registrados por você',
    totalRegistrations: 'Total de Cadastros',
    searchPlaceholder: 'Buscar por nome, placa, modelo ou CPF...',
    noResults: 'Nenhum resultado encontrado para a busca.',
    empty: 'Você ainda não possui cadastros registrados.',
    client: 'Cliente',
    cpf: 'CPF',
    color: 'Cor',
    products: 'Produtos',
    serial: 'Serial',
    local: 'Local',
    cert: 'Certificado',
    tapToView: 'Toque para ver certificado completo',
    loadingCerts: 'Carregando cadastros...',
    errorLoad: 'Erro ao carregar cadastros. Tente novamente.',
    retry: 'Tentar Novamente',
  },

  // CadastroPage (formulário principal)
  cadastro: {
    title: 'Cadastro de Aplicação',
    subtitle: 'Preencha todos os dados do cliente e da aplicação',
    applicator: 'Aplicador:',
    loading: 'Carregando...',
    // Client section
    clientSection: 'Dados do Cliente',
    cpfLabel: 'CPF * (digite e clique em buscar para verificar cliente existente)',
    cpfPlaceholder: 'Digite o CPF do cliente',
    searchCpf: 'Buscar CPF',
    searchingCpf: 'Buscando...',
    clientFound: 'Cliente encontrado! {{certs}} certificado(s) e {{vehicles}} veículo(s) registrado(s). Dados pessoais preenchidos. Preencha os dados do novo veículo.',
    clientExistsBanner: 'Cliente já cadastrado!',
    clientExistsBannerText: 'Dados pessoais preenchidos automaticamente. {{count}} veículo(s) registrado(s).',
    newClient: 'Novo Cliente',
    fullName: 'Nome Completo *',
    phone: 'Telefone *',
    email: 'Email',
    birthDate: 'Data de Nascimento',
    state: 'Estado *',
    stateSelect: 'Selecione...',
    address: 'Endereço Completo',
    cep: 'CEP',
    cepPlaceholder: '00000-000',
    cepError: 'CEP não encontrado. Preencha o endereço manualmente.',
    numero: 'Número',
    numeroPlaceholder: 'Nº',
    logradouro: 'Rua / Avenida',
    logradouroPlaceholder: 'Preenchido automaticamente pelo CEP',
    complemento: 'Complemento',
    complementoPlaceholder: 'Apto, bloco, etc. (opcional)',
    bairro: 'Bairro',
    cidade: 'Cidade',
    // Existing vehicles
    registeredVehicles: 'Veículos Cadastrados',
    registeredVehiclesHint: 'Veículos já registrados para este cliente. Selecione um para nova aplicação ou cadastre um novo abaixo.',
    selectVehicle: 'Selecionar este veículo',
    vehicleDataFilled: 'Dados do veículo preenchidos. Atualize os dados da aplicação.',
    colorLabel: 'Cor:',
    productsLabel: 'Produtos:',
    applicationLabel: 'Aplicação:',
    // Vehicle section
    vehicleSection: 'Dados do Veículo',
    newVehicleSection: 'Novo Veículo / Nova Aplicação',
    plate: 'Placa *',
    platePlaceholder: 'Ex: ABC1234',
    searchPlaca: '🔍 Buscar',
    searchingPlaca: 'Buscando...',
    placaHintSearching: '🔄 Consultando veículo...',
    placaHint: 'Busca automática ao digitar a placa completa',
    vehicleModel: 'Modelo do Carro *',
    yearModel: 'Ano e Modelo',
    yearPlaceholder: 'Preenchido automaticamente',
    color: 'Cor *',
    colorPlaceholder: 'Ex: Prata, Preto, Branco',
    vehicleFound: '✅ Veículo encontrado e dados preenchidos automaticamente!',
    vehicleError: 'Erro ao consultar veículo. Tente novamente.',
    // Application section
    applicationSection: '🔧 Dados da Aplicação',
    productsApplied: 'Produtos Aplicados *',
    noProducts: 'Nenhum produto selecionado',
    searchProducts: 'Digite para buscar produtos...',
    productsWarning: 'Selecione pelo menos um produto',
    serialNumbers: 'Serial Numbers * (um para cada produto)',
    serialPlaceholder: 'Serial number do {{product}}',
    applicationDate: 'Data da Aplicação *',
    applicationLocation: 'Local Aplicado *',
    locationPlaceholder: 'Ex: São Paulo - SP',
    // Photo section
    photoSection: '📸 Foto do Veículo',
    photoUpload: 'Clique para adicionar foto do veículo',
    photoFormats: 'Formatos: JPG, PNG, GIF (máx. 5MB)',
    removePhoto: 'Remover foto',
    fileTooLarge: '❌ O arquivo deve ter no máximo 5MB',
    fileTypeError: '❌ Apenas arquivos de imagem são permitidos',
    // Submit
    submit: 'Cadastrar Aplicação',
    submitting: 'Cadastrando...',
    successMessage: '✅ Cadastro realizado com sucesso! ID do Certificado: {{id}}',
    errorMessage: '❌ Erro ao realizar cadastro. Tente novamente.',
    selectOneProduct: '❌ Selecione pelo menos um produto aplicado',
    // Scanner
    scannerTitle: 'Escanear Código de Barras',
    scannerHint: 'Aponte a câmera para o código de barras do produto',
    scannerError: 'Não foi possível acessar a câmera. Verifique as permissões do navegador.',
    scannerTooltipTitle: '📷 Scanner de Código de Barras',
    scannerTooltipPurpose: 'Para ler automaticamente o número de série dos produtos usando a câmera do seu celular.',
    scannerTooltipHow: 'Como usar:',
    scannerStep1: 'Clique no ícone da câmera',
    scannerStep2: 'Permita o acesso à câmera quando solicitado',
    scannerStep3: 'Aponte a câmera para o código de barras do produto',
    scannerStep4: 'Aguarde o reconhecimento automático',
    scannerStep5: 'O número será preenchido automaticamente',
    scannerTip: 'Certifique-se que o código de barras está bem iluminado e sem reflexos.',
    // Nav
    myCerts: '📋 Meus Cadastros',
    // Tutorial
    tutorialButton: '❓ Tutorial',
    tutorialTitle: 'Como usar o app',
    tutorialStep1: 'Busque o cliente pelo CPF. Se ele já existir, os dados serão preenchidos automaticamente.',
    tutorialStep2: 'Preencha os dados pessoais do cliente (nome, telefone, e-mail, endereço).',
    tutorialStep3: 'Informe a placa do veículo para buscar automaticamente o modelo e a cor, ou preencha manualmente.',
    tutorialStep4: 'Selecione os produtos aplicados e informe o número de série de cada um (use o scanner de código de barras se preferir).',
    tutorialStep5: 'Escolha a data de aplicação, o estúdio onde o serviço foi realizado e adicione uma foto do veículo.',
    tutorialStep6: 'Clique em "Cadastrar Aplicação" para gerar o certificado.',
    tutorialHint: 'Você pode acessar todos os certificados já cadastrados na aba "Meus Cadastros".',
  },

  // EsqueciSenhaPage
  forgotPassword: {
    title: 'Recuperar Senha',
    subtitle: 'Digite seu email para receber instruções de recuperação',
    email: 'Email',
    emailPlaceholder: 'Digite seu email de cadastro',
    submit: 'Enviar Instruções',
    submitting: 'Enviando...',
    backToLogin: 'Voltar ao Login',
    howItWorks: 'Como funciona?',
    step1: '1. Digite seu email de cadastro',
    step2: '2. Se o email estiver cadastrado, você receberá as instruções',
    step3: '3. Siga as instruções no email para redefinir sua senha',
    notReceived: 'Não recebeu o email?',
    checkSpam: '• Verifique sua caixa de spam',
    waitMinutes: '• Aguarde alguns minutos',
    checkEmail: '• Certifique-se de que o email está correto',
    errorMessage: 'Erro ao processar solicitação. Tente novamente.',
  },

  // RedefinirSenhaPage
  resetPassword: {
    title: 'Redefinir Senha',
    verifying: 'Verificando link...',
    validatingLink: 'Validando seu link de redefinição...',
    invalidTitle: 'Link Inválido',
    invalidSubtitle: 'Este link não é mais válido',
    requestNewLink: 'Solicitar Novo Link',
    backToLogin: 'Voltar ao Login',
    newPassword: 'Nova Senha',
    newPasswordPlaceholder: 'Digite sua nova senha',
    confirmPassword: 'Confirmar Nova Senha',
    confirmPasswordPlaceholder: 'Confirme sua nova senha',
    showPasswords: 'Mostrar senhas',
    submit: 'Redefinir Senha',
    submitting: 'Redefinindo...',
    goToLogin: 'Ir para o Login',
    successSubtitle: 'Senha redefinida com sucesso!',
    enterNew: 'Digite sua nova senha',
    requirements: 'A senha deve conter:',
    minChars: 'No mínimo 8 caracteres',
    lowercase: 'Uma letra minúscula',
    uppercase: 'Uma letra maiúscula',
    number: 'Um número',
    passwordMismatch: 'As senhas não coincidem.',
    passwordMinLength: 'A senha deve ter pelo menos 8 caracteres.',
    passwordComplexity: 'A senha deve conter pelo menos uma letra minúscula, uma maiúscula e um número.',
    errorMessage: 'Erro ao redefinir senha. Tente novamente.',
  },

  // Footer
  footer: {
    rights: '© 2024 IGL Coatings Brasil. Todos os direitos reservados.',
    authenticity: 'Certificado de Autenticidade IGL Coatings',
  },

  // Warranty duration
  warranty: {
    year: '1 ano',
    years: '{{n}} anos',
    months: '{{n}} meses',
  },
};

export default pt;
